/**
 * FAQ chip dialogs.
 *
 * One delegated listener on the document rather than per-block wiring: the chips block can
 * appear more than once on a page, and its script tag is rendered per instance — binding
 * per instance would attach the same handler several times over.
 *
 * Uses the native <dialog> API, so the focus trap, Escape handling, backdrop and inert-ing
 * of the page behind come from the platform rather than from here.
 */
if (!window.__crewcupFaqChips) {
  window.__crewcupFaqChips = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-faq-open]');
    if (opener instanceof HTMLElement) {
      const dialog = document.getElementById(opener.dataset.faqOpen ?? '');
      if (dialog instanceof HTMLDialogElement) dialog.showModal();
      return;
    }

    if (target.closest('[data-faq-close]')) {
      target.closest('dialog')?.close();
      return;
    }

    // Clicking the backdrop. The backdrop is not its own element, so a click on it lands on
    // the dialog itself — an inner click always lands on a descendant instead.
    if (target instanceof HTMLDialogElement && target.classList.contains('cc-faq-dialog')) {
      target.close();
    }
  });
}
